export const SERVICE_TERMS_TEXT = `<서비스 이용약관>

제1조 (목적)

이 약관은 주식회사 알파영어(이하 “회사”라 합니다)가 제공하는 온라인 영어학습 시스템 ‘alphaca.co.kr’ 및 관련 모바일 애플리케이션·API 등(이하 통칭하여 “서비스”라 합니다)의 이용과 관련하여 회사와 본 약관에 동의한 학원 대표(이하 “학원”) 및 기타 이용자 간의 권리, 의무 및 책임, 서비스 이용 절차, 기타 필요한 사항을 정함을 목적으로 합니다.

제2조 (용어의 정의)

이 약관에서 사용하는 용어의 정의는 다음과 같습니다.

1. “서비스”란 회사가 개발·운영하는 영어학습 플랫폼 및 이에 부수된 제반 서비스를 말합니다.
2. “학원”이란 이 약관에 동의하고 회사와 서비스 이용계약을 체결한 사업자의 대표자를 말합니다.
3. “강사”란 고용형태와 관계없이 학원에 소속되어 근로계약을 체결한 근로자를 말합니다.
4. “학생”이란 학원이 서비스에 등록한 소속 학습자를 말합니다.
5. “학부모”란 학생의 성적, 채점표, 녹음 등에 접근할 수 있도록 학원이 지정한 법정대리인을 말합니다.
6. "이용자"란, 학원 및 그 소속원, 학부모 등이 계약, 요청등으로 서비스에 접근할 권한을 부여받고 서비스를 이용하는 모든 구성원을 말합니다.
6. “콘텐츠”란 서비스에서 제공하는 텍스트, 음성, 영상, 이미지, 소프트웨어, 알고리즘, 데이터베이스 등 일체의 자료를 의미합니다.
7. “유료 서비스”란 회사가 서비스 내에서 별도의 요금·구독료를 받고 제공하는 모든 서비스를 의미합니다.
8. “개인정보처리방침”이란 회사가 개인정보보호법 등 관련 법령에 따라 이용자의 개인정보를 어떻게 수집·이용·제공·보관·파기하는지에 대한 정책을 말합니다.

제3조 (약관의 효력 및 명시, 변경)

1. 본 약관은 서비스 화면 또는 기타 방법을 통해 게시하고 이용자가 동의함으로써 효력이 발생합니다.
2. 회사는 「약관의 규제에 관한 법률」, 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」, 「전자상거래 등에서의 소비자 보호에 관한 법률」 등 관계 법령을 위배하지 않는 범위에서 약관을 변경할 수 있습니다.
3. 회사가 약관을 변경할 경우 최소 7일 전에 서비스 내 공지 또는 전자우편 등 합리적인 방법으로 변경 내용을 공지합니다. 이용자가 공지일 이후 서비스를 계속 이용하는 경우 변경된 약관에 동의한 것으로 봅니다. 중요한 사항을 변경할 때에는 30일 이상 미리 공지하고 별도의 동의를 받을 수 있습니다.
4. 회사는 개인정보 처리와 관련하여 별도의 개인정보처리방침을 제정·운영하며, 서비스 이용 시 개인정보처리방침에 동의한 것으로 간주합니다. 약관과 개인정보처리방침이 충돌하는 경우 개인정보처리방침이 우선 적용됩니다.

제4조 (서비스 내용 및 제공 범위)

1. 회사는 영어학습 콘텐츠 제공, AI 기반 음성·작문 분석, 학습 관리 도구, 통계 리포트 제공 등 교육 관련 서비스를 제공합니다. 서비스의 구체적 내용은 회사의 정책에 따라 추가·변경될 수 있으며, 변경 시 공지합니다.
2. 회사는 서비스를 연중무휴, 1일 24시간 제공함을 원칙으로 하나, 설비 점검, 보수, 교체 또는 서비스 개선을 위해 필요하다고 판단되는 경우 사전 공지 후 서비스를 일시 중단할 수 있습니다.
3. 회사는 무료 서비스와 유료 서비스를 구분하여 제공할 수 있으며, 유료 서비스의 경우 별도의 요금 정책·이용조건·결제 방법을 정하여 공지합니다.

제5조 (유료 서비스, 결제 및 환불)

1. 학원은 서비스 내에서 안내되는 절차에 따라 정기 요금제, 좌석 기반 요금제 등 다양한 유료 서비스를 신청할 수 있습니다. 요금 정책은 회사 사정에 따라 변경될 수 있으며, 변경 시 사전 공지합니다.
2. 요금은 선불을 원칙으로 하며, 자동결제 등록 시 등록월 기준 1개월 단위로 청구됩니다. 등록 좌석 수 또는 선택한 요금제에 따라 월 청구액이 달라질 수 있습니다.
3. 청구 및 결제 정보는 학원 대표 또는 결제 담당자가 확인 가능한 이메일·전화번호 등으로 통지하며, 미납 시 서비스 이용이 제한될 수 있습니다.
4. 이용자가 유료 서비스를 해지하고자 할 경우 회사가 정한 신청 절차(고객센터, 이메일, 서면 등)에 따라 요청해야 하며, 해지 시 이미 납부한 요금은 약관 및 관련 법령이 정한 범위 내에서 환불됩니다.
5. 환불은 「전자상거래법」, 「콘텐츠산업진흥법」 등 관련 법령을 준수하여 처리하며, 서비스 이용 시작 후 환불 시 이용 기간에 따른 금액과 위약금이 공제될 수 있습니다.
6. 회사는 결제 대행사(PG) 또는 금융기관의 사정으로 결제 오류가 발생한 경우 신속히 정정 또는 취소를 진행하며, 이용자는 결제 내역을 반드시 확인해야 합니다.

제6조 (학원의 의무)

1. 학원은 서비스 이용 시 관련 법령과 본 약관, 이용안내, 공지사항 등을 준수하여야 하며, 타인의 권리를 침해하거나 서비스를 부정사용해서는 안 됩니다.
2. 학원은 학생·강사 등 소속 구성원의 계정정보를 안전하게 관리할 책임이 있으며, 계정 도용·정보 유출이 의심되는 경우 즉시 회사에 통보해야 합니다.
3. 학원은 서비스 이용을 위해 필요한 최소한의 장비 및 네트워크 환경을 자체적으로 준비해야 합니다.
4. 유료 서비스 안전 이용과 원활한 과금 처리를 위해 회사가 요청하는 자료(사업자등록증, 통장사본 등)를 제출해야 할 수 있습니다.

제7조 (회사의 의무)

1. 회사는 안정적인 서비스 제공을 위해 최선을 다하며, 설비 장애나 데이터 유실이 발생하지 않도록 지속적으로 관리·점검합니다.
2. 회사는 이용자의 개인정보를 관련 법령에 따라 보호하며, 개인정보처리방침에서 정한 목적 범위 내에서만 사용합니다.
3. 회사는 이용자가 정당한 이용 절차를 거쳐 서비스를 이용할 수 있도록 지원하며, 장애 또는 오류가 발생한 경우 신속히 복구합니다.

제8조 (콘텐츠의 저작권 및 이용제한)

1. 서비스에서 제공되는 모든 콘텐츠의 저작권과 지식재산권은 회사 또는 해당 권리자에게 귀속됩니다.
2. 이용자는 회사가 허용한 범위 내에서만 콘텐츠를 사용할 수 있으며, 무단 복제·배포·전송·전시 등은 금지됩니다.
3. 이용자가 본 조를 위반하여 발생하는 민형사상의 책임은 이용자에게 있습니다.

제9조 (개인정보 보호 및 연락처)

1. 회사는 개인정보 보호를 위해 개인정보처리방침을 수립·공개하고, 관련 법령이 요구하는 기술적·관리적 보호조치를 이행합니다.
2. 회사는 이용자의 개인정보를 서비스 제공 목적 범위 내에서만 이용하며, 법령에서 허용하는 경우를 제외하고 제3자에게 제공하지 않습니다.
3. 회사는 개인정보 유출, 분실, 훼손 등이 발생하지 않도록 관리하며, 「개인정보 보호법」 등 관계 법령을 준수합니다.

제10조 (서비스 제한 및 계약 해지)

1. 이용자가 약관을 위반하거나 서비스 운영을 심각하게 방해하는 경우 회사는 사전 통지 후 서비스 이용을 제한하거나 계약을 해지할 수 있습니다.
2. 회사가 계약을 해지하는 경우, 이용자가 보유한 좌석·서비스 이용 권한은 즉시 중단되며, 미사용분 환불 여부는 관련 법령 및 본 약관에서 정한 바를 따릅니다.
3. 이용자가 계약 해지를 원하는 경우 회사가 정한 절차에 따라 해지 신청을 해야 하며, 해지 전까지 발생한 요금 청구 등 권리·의무는 약관 및 개별 약정에 따릅니다.

제11조 (손해배상)

1. 이용자가 약관을 위반하거나 불법행위 등으로 회사에 손해를 입힌 경우 해당 이용자는 회사가 입은 손해를 배상해야 합니다.
2. 회사는 천재지변, 전쟁, 테러, 정부 규제, 기간통신사업자의 서비스 중단 등 불가항력으로 인해 서비스를 제공할 수 없는 경우 책임을 지지 않습니다.

제12조 (면책 조항)

1. 회사는 이용자의 귀책 사유로 인해 발생한 서비스 이용 장애에 대해서는 책임을 지지 않습니다.
2. 회사는 학원이 제공하는 정보의 정확성, 신뢰성 등을 보증하지 않으며, 학원과 학생·학부모 간 또는 이용자 상호 간 분쟁에 개입하지 않습니다.

제13조 (통지)

1. 회사가 특정 이용자에게 통지를 하는 경우 약관에 별도 규정이 없는 한 이용자가 제공한 전자우편, 문자메시지, 알림톡 등으로 할 수 있습니다.
2. 불특정 다수 이용자에 대한 통지는 7일 이상 서비스 내 공지사항 게시로 갈음할 수 있습니다.

제14조 (준거법 및 관할)

1. 이 약관과 서비스 이용과 관련하여 회사와 이용자 간에 발생한 분쟁에는 대한민국 법을 준거법으로 합니다.
2. 분쟁이 발생할 경우 회사 소재지를 관할하는 서울중앙지방법원을 전속관할법원으로 합니다.

부칙

1. 이 약관은 2026년 1월 1일부터 시행합니다.
2. 시행일 이전 가입된 이용자에 대해서도 본 약관이 적용됩니다.`;

export const PRIVACY_POLICY_TEXT = `<개인정보 처리방침>

주식회사 알파영어(이하 “회사”)는 개인정보보호법 등 관련 법령을 준수하며, 이용자의 개인정보를 안전하게 보호하고 성실히 관리합니다.

본 방침은 회사가 제공하는 영어학습 서비스(www.alphaca.co.kr)에 적용되며, 개인정보의 수집·이용 목적, 보유 및 이용 기간, 제3자 제공 및 위탁, 이용자의 권리와 행사 방법, 파기 절차, 안전조치 등을 규정합니다.

제1조 (개인정보의 처리 목적)

회사는 다음의 목적을 위해 개인정보를 최소한으로 수집·이용하며, 목적 외 사용 시에는 사전 동의를 받습니다.

1. 서비스 회원가입 및 관리: 학원 사업장 진위 확인, 이용자 식별, 이용계약 체결 및 이행, 공지사항 전달 등
2. 영어 학습 콘텐츠 제공 및 운영: 학생 과제 및 시험 배정, 학습 이력 관리, 강사·학원·학생 간 정보 연동
3. 학부모 안내 기능 제공: 성적 확인, 녹음 확인, 학습 리포트 전달 등
4. 고객 문의 응대 및 불만 처리: 본인 확인, 민원 대응, 고지사항 전달
5. 유료 서비스 이용 및 요금 정산: 정기결제 등록, 자동결제 승인, 청구 내역 확인 및 환불 처리

제2조 (처리하는 개인정보 항목 및 수집 방법)

[수집 항목]
- 학원 대표자: ID, 비밀번호, 이름, 휴대전화번호, 이메일, 사업자등록번호
- 강사: ID, 비밀번호, 이름, 이메일(선택), 소속 학원 정보
- 학생: ID, 비밀번호, 이름, 생년월일, 소속 학원 정보, 학습 성적, 학습 이력, 녹음/답변 데이터
- 학부모: 이메일(선택), 자녀 정보 연동(교재 채점표, 성적표 등)
- 결제정보: 납부 내역, PG사 식별자, 계좌번호 또는 카드번호 (암호화 저장)

※ AI 음성 분석 및 영작 평가 기능을 사용하는 경우, 학생의 음성 및 텍스트 정보가 추가로 수집됩니다. 해당 정보는 학습 분석 목적 종료 후 7일간 저장되며, 필요 시 최대 30일까지 보관 후 자동 삭제됩니다.

[수집 방법]
- 회원가입, 학원 관리자 등록, 유료 결제 신청, 고객센터 문의 과정에서 직접 수집
- 서비스 이용 중 자동 생성되는 정보(IP 주소, 접속 기록, 쿠키, 브라우저 정보 등)

제3조 (개인정보의 보유 및 이용 기간)

회사는 개인정보 수집·이용 목적이 달성되면 지체 없이 파기합니다. 단, 관련 법령에 따라 일정 기간 보존할 필요가 있는 경우 또는 사전 동의가 있는 경우에는 아래 기준에 따라 보유합니다.

- 회원 정보(학원 및 학원의 구성원): 회원 탈퇴, 또는 학원의 서비스 해지 시까지
- 학생 및 학부모 정보: 학원 탈퇴 또는 학습 종료 후 1년
- 결제 및 요금 정보: 전자상거래법에 따라 5년
- 녹음파일 및 AI 분석 결과: 수집 후 기본 7일, 운영상 필요에 따라 최대 30일 이내에서 연장 후 자동 삭제
- 그 외 관련 법령에 따른 보존 항목: 법정 기한까지

제4조 (개인정보의 제3자 제공)

회사는 이용자의 개인정보를 원칙적으로 외부에 제공하지 않으며, 다음의 경우에만 예외적으로 제공합니다.

1. 이용자 또는 법정대리인의 사전 동의가 있는 경우
2. 관계 법령에 근거하거나 수사기관의 요청이 있는 경우
3. 학습 콘텐츠 제공을 위한 외부 AI 분석 솔루션과의 연동이 필요한 경우(사전 안내 후 연동)

제5조 (개인정보의 처리 위탁)

회사는 원활한 서비스 제공을 위하여 일부 업무를 외부에 위탁하고 있으며, 수탁자와는 개인정보 보호에 관한 계약을 체결하고 관리·감독을 수행합니다.

- Amazon Web Services : 클라우드 서버 운영 및 데이터 저장
- 토스페이먼츠(PG): 결제 처리, 자동결제, 환불 정산
- AI 평가 업체: 음성 분석, 영작 자동 채점

제6조 (쿠키의 사용과 거부)

회사는 이용자 맞춤형 서비스를 제공하기 위해 쿠키(cookie)를 사용할 수 있습니다. 쿠키는 웹사이트 이용 시 브라우저에 저장되는 소규모 데이터로, 사용자의 기기정보 및 방문기록 등을 포함할 수 있습니다.

- 이용자는 브라우저 설정에서 쿠키 저장을 거부할 수 있습니다. 다만, 이 경우 일부 서비스 이용이 제한될 수 있습니다.
- 쿠키 설정 방법: [예시] Chrome 기준 – 설정 > 개인정보 및 보안 > 쿠키 및 기타 사이트 데이터

제7조 (이용자 및 법정대리인의 권리와 행사 방법)

1. 이용자 및 법정대리인은 언제든지 본인의 개인정보에 대해 열람, 정정, 삭제, 처리정지 등을 요청할 수 있습니다.
2. 만 14세 미만 아동의 개인정보는 반드시 법정대리인의 동의를 통해 수집되며, 동의 확인과 증빙 자료의 보관은 학원 관리자에게 위임합니다.
3. 권리 행사는 이메일(alphaengessay@gmail.com), 고객센터(02-2651-7105) 또는 서면 요청을 통해 가능하며, 본인확인 절차 후 지체 없이 조치됩니다.
4. 개인정보 오류 정정 요청 시 정정 완료 전까지 해당 정보를 이용하거나 제3자에게 제공하지 않으며, 이미 제3자에게 제공된 경우 정정 사실을 통지합니다.

제8조 (개인정보의 파기 절차 및 방법)

회사는 개인정보 보유 기간이 종료되거나 처리 목적이 달성된 후 지체 없이 해당 정보를 파기합니다.

- 전자 파일: 복구 불가능한 기술적 방식으로 삭제
- 종이 문서: 분쇄 또는 소각

제9조 (개인정보의 안전성 확보 조치)

회사는 개인정보보호법에 따라 개인정보를 안전하게 처리하기 위하여 다음과 같은 조치를 취합니다.

1. 비밀번호, 결제정보 등의 암호화 저장 및 전송
2. 개인정보 처리 직원 최소화 및 접근권한 관리 
3. 접근 기록 보관 및 이상 탐지 시스템 운영
4. 정기적인 보안 점검 및 수탁자 관리 감독
5. 침입 차단 시스템, 백신 프로그램 등 보안솔루션 운영

제10조 (개인정보 보호책임자 및 문의처)

회사는 개인정보 처리에 대한 총괄 책임자를 지정하고 있으며, 관련 문의·불만·권리 행사 요청은 아래 연락처를 통해 하실 수 있습니다.

- 성명: 이광식
- 직책: 대표이사 (CEO)
- 이메일: alphaengessay@gmail.com
- 연락처: 02-2651-7105
- 주소: 서울특별시 양천구 중앙로23길 32 씨엘프라자 9층

또한, 개인정보 침해에 대한 상담이나 신고는 아래 기관을 통해 가능합니다.

- 개인정보침해신고센터 (privacy.kisa.or.kr / 118)
- 개인정보분쟁조정위원회 (kopico.go.kr / 1833-6972)

제11조 (개인정보 처리방침의 변경)

1. 본 방침은 법령 개정, 서비스 구조 변경 등에 따라 수시로 개정될 수 있으며, 개정 시 최소 7일 전(중대한 변경의 경우 30일 전) 사전 공지됩니다.
2. 공지 방법: 홈페이지 팝업, 이메일, 서비스 내 알림 등
3. 이 방침은 2026년 1월 1일부터 시행됩니다.`;

